// =========================================================
// * Vuetify Material Dashboard PRO - v1.0.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueTheMask from 'vue-the-mask'
import VueGeolocation from 'vue-browser-geolocation'
import InsuranceForm from './views/dashboard/InsuranceForm.vue'
import InsuranceList from './views/dashboard/Insurance-list.vue'
import VehicleForm from './views/dashboard/VehicleForm.vue'
import VehicleList from './views/dashboard/Vehicle-list.vue'
import ClientsForm from './views/dashboard/components/Clients-form.vue'
Number.prototype.money = function () {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
  }).format(this)
}
Vue.component('InsuranceList', InsuranceList)
Vue.component('InsuranceForm', InsuranceForm)
Vue.component('VehicleForm', VehicleForm)
Vue.component('VehicleList', VehicleList)
Vue.component('ClientsForm', ClientsForm)
Vue.use(VueGeolocation)
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  // store.state.toolbar.show = true
  // if (to.path == '/') next('/dashboard')
  if (to.path === '/logout') {
    window.localStorage.removeItem('token')
    next('/pages/login')
  } else
  if (to.path === '/pages/login' || to.path === '/pages/recover' || to.path.startsWith('/photo/upload')) {
    // store.state.toolbar.show = false
    next()
  } else {
    window.axios.post('/api/auth/check/', {lock: store.state.lock})
        .then(response => {
          if (!response.data.error) {
            // store.state.user = response.data.user
            store.commit('user', response.data.user)
            store.commit('client', response.data.client)
            if (response.data.token) localStorage.setItem('token', response.data.token)
            let obj = {}
            for (let x in response.data.dictionaries) {
              let dict = response.data.dictionaries[x]
              let data = {}
              for (let y in dict.data) {
                if (dict.data[y].enabled) {
                  data[dict.data[y].value] = dict.data[y].data
                }
              }
              obj[dict.name] = data
            }
            obj['log'] = {
              1: 'Создание клиента',
              2: 'Изменение клиента',
              3: 'Создание события',
              4: 'Изменение события',
              5: 'Создание договора',
              6: 'Изменение договора',
              7: 'Создание пользователя',
              8: 'Изменение пользователя',
              9: 'Регистрация пользователя',
              10: 'Создание словаря',
              11: 'Изменение словаря',
              12: 'Авторизация пользователя',
              13: 'Создание настроек',
              14: 'Изменение настроек',
              15: 'Создание ссылки на фото',
              16: 'Изменение ссылки на фото',
              17: 'Создание ДТП',
              18: 'Изменение ДТП',
              19: 'Создание комментария',
              20: 'Изменение комментария'
            },
            console.log(obj)
            store.commit('dictionary', obj)
            store.commit('settings', response.data.settings)
            if (response.data.user.role == 5) {
              if (to.path === '/accident/create/short' || to.path == '/accident/list/short' || to.path == '/') { next() } else {
                next('/')
              }
            } else {
              next()
            }
          } else {
            next('/pages/login')
        }
      })
      .catch(e => {
        console.log(e)
        next('/pages/login')
      })
  }
})
Vue.use(VueTheMask)
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
